$('.playpause').click(function () {
  if($(this).prev(".video").get(0).paused){
    $(this).prev(".video").get(0).play();
    $(this).fadeOut();
  }
});


// WEBPACK FOOTER //
// ./src/js/general/bac-video.js